import _slicedToArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/ecomm-marketplace/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import moment from 'moment-timezone';
import { getSpecialHoursDays, openInfoForDispensary } from 'shared/core/helpers/dispensaries';
import { dayIdToDayOfWeek, daysOfWeek } from 'shared/constants';
import { createTimeSlot, stripNextDaySuffix, hasNextDaySuffix } from 'shared/helpers/time-utils';
function daysDefault() {
  return {
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: []
  };
}

// Takes slot data coming back from the reservation_slots table and organizes it into maxReservationSlotsByDay and
// maxReservationSlotsByDate for each orderType
export var formatAndOrganizeSlots = function formatAndOrganizeSlots(_ref) {
  var slots = _ref.slots,
    includeCurrentCount = _ref.includeCurrentCount,
    includeDayOfWeek = _ref.includeDayOfWeek,
    includeSlotId = _ref.includeSlotId,
    timezone = _ref.timezone;
  var orderTypeSlots = {
    curbsidePickup: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    },
    delivery: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    },
    driveThruPickup: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    },
    inStorePickup: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    }
  };
  var sortedSlots = _.sortBy(slots, ['reservation_type', 'day_of_week', 'start_at']);
  _.forEach(sortedSlots, function (slot) {
    // if bad order/reservation type is present, ignore
    if (!Object.keys(orderTypeSlots).includes(slot.reservation_type)) {
      return;
    }
    var effectiveDayOfWeek = dayIdToDayOfWeek[slot.day_of_week];
    var orderTypeSlotsConfig = orderTypeSlots[slot.reservation_type];

    // Use the pre-stored flag instead of complex calculation
    var isNextDaySlot = slot.is_next_day_slot;
    var startTime = moment.tz(slot.start_at, 'HH:mm', timezone);
    var formattedSlot = _objectSpread(_objectSpread(_objectSpread({
      startTime: slot.start_at,
      endTime: startTime.add(slot.duration, 'minutes').format('HH:mm'),
      maxOrders: slot.max_orders,
      deliveryAreaId: slot.delivery_area_id,
      active: slot.active,
      isNextDaySlot: isNextDaySlot
    }, includeCurrentCount && {
      currentCount: slot.current_count
    }), includeDayOfWeek && {
      dayOfWeek: effectiveDayOfWeek
    }), includeSlotId && {
      slotId: slot.id
    });
    if (!slot.valid_to) {
      orderTypeSlotsConfig.maxReservationSlotsByDay[effectiveDayOfWeek].push(formattedSlot);
    } else {
      orderTypeSlotsConfig.maxReservationSlotsByDate.push(_objectSpread(_objectSpread({}, formattedSlot), {}, {
        date: moment(slot.valid_to).tz(timezone).format('YYYY-MM-DD')
      }, includeDayOfWeek && {
        dayOfWeek: effectiveDayOfWeek
      }));
    }
  });
  return orderTypeSlots;
};

// Merges special hour slots on top of standard hour slots for the next week
var mergeOrderTypeSlots = function mergeOrderTypeSlots(orderTypeSlots, timezone) {
  var today = moment.tz(timezone).startOf('day');
  var oneWeekLater = moment.tz(timezone).add(6, 'days').endOf('day');
  var filteredMaxReservationSlotsByDate = _.filter(orderTypeSlots.maxReservationSlotsByDate, function (slot) {
    return slot.date && moment.tz(slot.date, timezone).isBetween(today, oneWeekLater, undefined, '[]');
  });
  var specialSlotsForDaysOfWeek = _.reduce(filteredMaxReservationSlotsByDate, function (weekObj, slot) {
    if (!weekObj[slot.dayOfWeek]) {
      weekObj[slot.dayOfWeek] = [];
    }
    weekObj[slot.dayOfWeek].push(slot);
    return weekObj;
  }, {});
  return _objectSpread(_objectSpread({}, orderTypeSlots.maxReservationSlotsByDay), specialSlotsForDaysOfWeek);
};
var getAdvancedDayOrderingAvailableDays = function getAdvancedDayOrderingAvailableDays(availableDays, today, dayIndex, dayLimit, effectiveHoursForOrderType) {
  var _effectiveHoursForOrd;
  var currentDay = moment(today).add(dayIndex, 'day');
  availableDays.push({
    date: currentDay.format('MM/DD/YYYY'),
    dayOfWeek: currentDay.format('dddd'),
    isClosed: ((_effectiveHoursForOrd = effectiveHoursForOrderType[currentDay.format('dddd')]) === null || _effectiveHoursForOrd === void 0 ? void 0 : _effectiveHoursForOrd.active) === false
  });
  var nextDayIndex = dayIndex + 1;
  if (nextDayIndex > dayLimit) {
    return availableDays;
  }
  return getAdvancedDayOrderingAvailableDays(availableDays, today, nextDayIndex, dayLimit, effectiveHoursForOrderType);
};

// Gets available slot reservations based on formatted data from free_reservation route
export var getCurrentSlotsForOrderType = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderType, dispensary, orderTypeSlots) {
    var _scheduledOrderingCon, _openInfo$orderType;
    var timezone, effectiveHours, _dispensary$orderType, enableAfterHoursOrdering, scheduledOrderingConfigV2, openInfo, nextOpenMoment, today, nextOpenDay, todayDate, todayDayOfWeek, nextOpenDate, nextOpenDayOfWeek, nextAvailableBuffer, nextAvailableTime, availableDays, mergedOrderTypeSlots, notDeliveryOrder, availableSlots, sortedSlots;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          timezone = dispensary.timezone;
          effectiveHours = dispensary.hoursSettings[orderType].effectiveHours;
          _dispensary$orderType = dispensary.orderTypesConfigV2[orderType], enableAfterHoursOrdering = _dispensary$orderType.enableAfterHoursOrdering, scheduledOrderingConfigV2 = _dispensary$orderType.scheduledOrderingConfigV2;
          openInfo = openInfoForDispensary(dispensary, {});
          nextOpenMoment = _.get(openInfo, "".concat(orderType, ".nextService.openMoment"));
          if (nextOpenMoment) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", []);
        case 7:
          // No open hours for this orderType
          today = moment.tz(timezone);
          nextOpenDay = nextOpenMoment.tz(timezone);
          todayDate = today.format('MM/DD/YYYY');
          todayDayOfWeek = today.format('dddd');
          nextOpenDate = nextOpenDay.format('MM/DD/YYYY');
          nextOpenDayOfWeek = nextOpenDay.format('dddd');
          nextAvailableBuffer = (_scheduledOrderingCon = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.nextAvailableInMinutes) !== null && _scheduledOrderingCon !== void 0 ? _scheduledOrderingCon : 10;
          nextAvailableTime = moment.tz(timezone).add(nextAvailableBuffer, 'minutes');
          availableDays = [];
          if (scheduledOrderingConfigV2 !== null && scheduledOrderingConfigV2 !== void 0 && scheduledOrderingConfigV2.advancedDayOrderingEnabled) {
            availableDays = getAdvancedDayOrderingAvailableDays([], today, 0, (scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) || 1, effectiveHours);
          } else if (!((_openInfo$orderType = openInfo[orderType]) !== null && _openInfo$orderType !== void 0 && _openInfo$orderType.isClosed)) {
            availableDays.push({
              date: todayDate,
              dayOfWeek: todayDayOfWeek
            });
          } else if (enableAfterHoursOrdering) {
            availableDays.push({
              date: nextOpenDate,
              dayOfWeek: nextOpenDayOfWeek
            });
          }
          mergedOrderTypeSlots = mergeOrderTypeSlots(orderTypeSlots, timezone);
          notDeliveryOrder = orderType !== 'delivery';
          availableSlots = _.reduce(availableDays, function (totalSlots, _ref3) {
            var date = _ref3.date,
              dayOfWeek = _ref3.dayOfWeek,
              isClosed = _ref3.isClosed;
            if (isClosed) {
              return totalSlots;
            }
            var slotsPerDay = _.reduce(mergedOrderTypeSlots === null || mergedOrderTypeSlots === void 0 ? void 0 : mergedOrderTypeSlots[dayOfWeek], function (slots, slot) {
              // If it's a "next day" slot, we need to adjust the date to the next day so that the time is technically correct
              var slotDate = slot.isNextDaySlot ? moment(date, 'MM/DD/YYYY').add(1, 'day').format('MM/DD/YYYY') : date;
              var _createTimeSlot = createTimeSlot(slot.startTime, slot.endTime, slotDate, timezone),
                startTimeISO = _createTimeSlot.startTimeISO,
                endTimeISO = _createTimeSlot.endTimeISO;
              var startTime = moment(startTimeISO);
              var quantityRemaining = 500;
              if (slot.deliveryAreaId || scheduledOrderingConfigV2 !== null && scheduledOrderingConfigV2 !== void 0 && scheduledOrderingConfigV2.orderLimitsEnabled) {
                quantityRemaining = slot.maxOrders - slot.currentCount;
              }

              // Skip slots with no capacity
              if (slot.maxOrders === 0) {
                return slots;
              }
              if (notDeliveryOrder) {
                // Skip slots where nextAvailableTime is after the slot ends (slot is too early)
                if (nextAvailableTime.isAfter(endTimeISO)) {
                  return slots;
                }
              } else if (startTime.isBefore(nextAvailableTime)) {
                // Skip delivery slots that start before nextAvailableTime
                return slots;
              }

              /*
               * NOTE: currently preventing a quantityRemaining value under 0, even if an admin adjusts the maxOrder value
               * on a timeslot below the currently reserved orders within that timeslot. This could easily be removed if
               * having that information is needed later (in an error warning while updating settings, for example)
               */
              slots.push(_objectSpread({
                slotId: slot.slotId,
                deliveryAreaId: slot.deliveryAreaId,
                active: slot.active,
                startTimeISO: startTimeISO,
                endTimeISO: endTimeISO,
                quantityRemaining: quantityRemaining < 0 ? 0 : quantityRemaining,
                isNextDaySlot: slot.isNextDaySlot
              }, slot.dayOfWeek && {
                dayOfWeek: slot.dayOfWeek
              }));
              return slots;
            }, []);
            return [].concat(_toConsumableArray(totalSlots), _toConsumableArray(slotsPerDay));
          }, []);
          sortedSlots = _.sortBy(availableSlots, 'startTimeISO');
          return _context.abrupt("return", sortedSlots);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCurrentSlotsForOrderType(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

// Fills in currentCount and maxOrders data for a slot based on previous reservationConfig data
var hydrateSlotData = function hydrateSlotData(reservationOptions, day, startTime, endTime, date) {
  var _reservationOptions$m;
  var slots = date ? reservationOptions === null || reservationOptions === void 0 ? void 0 : reservationOptions.maxReservationSlotsByDate : reservationOptions === null || reservationOptions === void 0 || (_reservationOptions$m = reservationOptions.maxReservationSlotsByDay) === null || _reservationOptions$m === void 0 ? void 0 : _reservationOptions$m[day];
  var getMaxOrders = function getMaxOrders(maxOrdersValue) {
    if (maxOrdersValue === undefined) {
      return 500;
    }
    if (maxOrdersValue === '') {
      return 0;
    }
    return maxOrdersValue;
  };
  if (!slots) {
    return {
      currentCount: 0,
      maxOrders: 500
    };
  }
  var predicate = date ? function (slot) {
    var slotDate = _.isString(slot.date) ? slot.date : moment.utc(slot.date).format('YYYY-MM-DD');
    return date === slotDate && startTime === slot.startTime && endTime === slot.endTime;
  } : function (slot) {
    return startTime === slot.startTime && endTime === slot.endTime;
  };
  var matchingSlot = _.find(slots, predicate);
  if (matchingSlot) {
    return {
      currentCount: (matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCount) || 0,
      maxOrders: getMaxOrders(matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.maxOrders),
      slotId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.slotId
    };
  }
  return {
    currentCount: 0,
    maxOrders: 500
  };
};
var hydrateSlotDataV2 = function hydrateSlotDataV2(reservationOptions, day, startTime, endTime, date, reservationType, zone) {
  var _reservationOptions$m2;
  var isNextDaySlot = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var slots = date ? reservationOptions === null || reservationOptions === void 0 ? void 0 : reservationOptions.maxReservationSlotsByDate : reservationOptions === null || reservationOptions === void 0 || (_reservationOptions$m2 = reservationOptions.maxReservationSlotsByDay) === null || _reservationOptions$m2 === void 0 ? void 0 : _reservationOptions$m2[day];
  var getMaxOrders = function getMaxOrders(maxOrdersValue) {
    if (maxOrdersValue === undefined) {
      return 500;
    }
    if (maxOrdersValue === '') {
      return 0;
    }
    return maxOrdersValue;
  };
  if (!slots) {
    return {
      currentCount: 0,
      maxOrders: 500,
      deliveryAreaId: zone.name,
      active: true
    };
  }
  var predicate = date ? function (slot) {
    var _slot$isNextDaySlot;
    var slotDate = _.isString(slot.date) ? slot.date : moment.utc(slot.date).format('YYYY-MM-DD');
    return date === slotDate && startTime === slot.startTime && endTime === slot.endTime && zone.name === slot.deliveryAreaId && ((_slot$isNextDaySlot = slot.isNextDaySlot) !== null && _slot$isNextDaySlot !== void 0 ? _slot$isNextDaySlot : false) === isNextDaySlot;
  } : function (slot) {
    var _slot$isNextDaySlot2;
    return startTime === slot.startTime && endTime === slot.endTime && zone.name === slot.deliveryAreaId && ((_slot$isNextDaySlot2 = slot.isNextDaySlot) !== null && _slot$isNextDaySlot2 !== void 0 ? _slot$isNextDaySlot2 : false) === isNextDaySlot;
  };
  var matchingSlot = _.find(slots, predicate);
  if (matchingSlot) {
    return {
      currentCount: (matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCount) || 0,
      maxOrders: getMaxOrders(matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.maxOrders),
      slotId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.slotId,
      deliveryAreaId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.deliveryAreaId,
      active: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.active
    };
  }
  return {
    currentCount: 0,
    maxOrders: 500,
    deliveryAreaId: zone.name,
    active: true
  };
};

// Creates slots given a start time up to an end time spaced by increment, hydrating with previously stored maxOrders
var getTimeSlots = function getTimeSlots(reservationOptionsForOrderType, day, dayStartTimeString, dayEndTimeString, increment, date, reservationType, deliveryZones, deliveryMode) {
  // Handle Next Day suffix in time strings using utilities
  var actualDayStartTimeString = stripNextDaySuffix(dayStartTimeString);
  var actualDayEndTimeString = stripNextDaySuffix(dayEndTimeString);
  var isEndTimeNextDay = hasNextDaySuffix(dayEndTimeString);
  var dayStartTime = actualDayStartTimeString === 'open' ? moment('12:00 AM', 'h:mm A') : moment(actualDayStartTimeString, 'h:mm A');
  var dayEndTime = actualDayEndTimeString === 'open' || actualDayEndTimeString === '12:00 AM' ? moment('11:59:59 PM', 'h:mm:ss A') : moment(actualDayEndTimeString, 'h:mm A');

  // If end time is next day, we need to extend the end time comparison
  if (isEndTimeNextDay && actualDayEndTimeString !== 'open' && actualDayEndTimeString !== '12:00 AM') {
    dayEndTime.add(1, 'day');
  }
  var formattedDate = date ? moment.utc(date).format('YYYY-MM-DD') : undefined;

  // Track whether we've crossed midnight during slot generation
  var hasCrossedMidnight = false;

  /**
   * Determines if a slot is in the "next day" portion of extended hours
   * @param {moment.Moment} slotTime - The slot start time
   * @param {moment.Moment} previousSlotTime - The previous slot time (to detect midnight crossing)
   * @returns {boolean} - True if this slot is in the extended hours (next day) portion
   */
  var isSlotNextDay = function isSlotNextDay(slotTime, previousSlotTime) {
    // Only extended hours can have next-day slots
    if (!isEndTimeNextDay) {
      return false;
    }

    // Detect if we've crossed midnight by checking if current slot is earlier than previous
    if (previousSlotTime && slotTime.hour() < previousSlotTime.hour() && previousSlotTime.hour() >= 22) {
      hasCrossedMidnight = true;
    }

    // If we haven't crossed midnight yet, early morning slots are current day
    if (!hasCrossedMidnight) {
      return false;
    }

    // After crossing midnight, early morning slots (0-6 AM) are next day
    return slotTime.hour() >= 0 && slotTime.hour() <= 6;
  };
  var createSlots = function createSlots(slots, slotStartTime) {
    var previousSlotTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (slotStartTime.isSameOrAfter(dayEndTime)) {
      return slots;
    }
    var slotStartTimeString = slotStartTime.format('HH:mm');
    var slotEndTime = moment(slotStartTime).add(increment, 'm');
    var slotEndTimeString = slotEndTime.format('HH:mm');
    var slotEndTimeAdjusted = slotEndTimeString === '00:00' ? moment('23:59:59', 'HH:mm:ss') : slotEndTime;
    var lastSlotDisjointed = slotEndTimeAdjusted.isAfter(dayEndTime);
    if (lastSlotDisjointed) {
      slotEndTimeString = actualDayEndTimeString === 'open' || actualDayEndTimeString === '12:00 AM' ? '00:00' : dayEndTime.format('HH:mm');
    }

    // Determine if this slot is in the next day portion
    var isNextDaySlot = isSlotNextDay(slotStartTime, previousSlotTime);
    if (deliveryZones && deliveryZones.length > 0 && reservationType === 'delivery' && deliveryMode === 'drawn') {
      deliveryZones.forEach(function (zone) {
        var hydratedSlotData = hydrateSlotDataV2(reservationOptionsForOrderType, day, slotStartTimeString, slotEndTimeString, formattedDate, reservationType, _objectSpread({}, zone), isNextDaySlot);
        slots.push(_objectSpread(_objectSpread({}, formattedDate && {
          date: formattedDate
        }), {}, {
          startTime: slotStartTimeString,
          endTime: slotEndTimeString,
          maxOrders: hydratedSlotData.maxOrders,
          currentCount: hydratedSlotData.currentCount,
          slotId: hydratedSlotData.slotId,
          deliveryAreaId: hydratedSlotData.deliveryAreaId,
          active: hydratedSlotData.active,
          isNextDaySlot: isNextDaySlot // Store the next day determination
        }));
      });
      if (lastSlotDisjointed) {
        return slots;
      }
      return createSlots(slots, slotEndTime, slotStartTime);
    }
    var hydratedSlotData = hydrateSlotData(reservationOptionsForOrderType, day, slotStartTimeString, slotEndTimeString, formattedDate, reservationType);
    slots.push(_objectSpread(_objectSpread({}, formattedDate && {
      date: formattedDate
    }), {}, {
      startTime: slotStartTimeString,
      endTime: slotEndTimeString,
      maxOrders: hydratedSlotData.maxOrders,
      currentCount: hydratedSlotData.currentCount,
      slotId: hydratedSlotData.slotId,
      isNextDaySlot: isNextDaySlot // Store the next day determination
    }));
    if (lastSlotDisjointed) {
      return slots;
    }
    return createSlots(slots, slotEndTime, slotStartTime);
  };
  return createSlots([], dayStartTime);
};

// Generates all possible slots for a particular order type per day of the week based on an increment
var getOrderTypeSlotsByDay = function getOrderTypeSlotsByDay(isOrderTypeOffered, orderTypeHours, orderTypeSpecialHours, reservationOptionsForOrderType, reservationType, deliveryZones, deliveryMode) {
  var incrementInMinutes = (reservationOptionsForOrderType === null || reservationOptionsForOrderType === void 0 ? void 0 : reservationOptionsForOrderType.incrementInMinutes) || 30;
  var standardSlots = {};
  var specialSlots = {};
  _.forEach(daysOfWeek, function (day) {
    var dayValue = day.value;
    if (!orderTypeHours[dayValue] || !orderTypeHours[dayValue].active) {
      standardSlots[dayValue] = [];
    } else {
      standardSlots[dayValue] = getTimeSlots(reservationOptionsForOrderType, dayValue, orderTypeHours[dayValue].start, orderTypeHours[dayValue].end, incrementInMinutes, '', reservationType, deliveryZones, deliveryMode);
    }
    if (isOrderTypeOffered && orderTypeSpecialHours[dayValue]) {
      if (!orderTypeSpecialHours[dayValue].active) {
        specialSlots[dayValue] = [];
      } else {
        specialSlots[dayValue] = getTimeSlots(reservationOptionsForOrderType, dayValue, orderTypeSpecialHours[dayValue].start, orderTypeSpecialHours[dayValue].end, incrementInMinutes, orderTypeSpecialHours[dayValue].date, reservationType, deliveryZones, deliveryMode);
      }
    }
  });
  return {
    standard: standardSlots,
    special: specialSlots
  };
};

// Updated method to work with new ordering and hours settings by type
var getSpecialHoursWithinNextWeek = function getSpecialHoursWithinNextWeek(specialHours, timezone) {
  var specialHoursWithinWeek = {};
  if (!specialHours) {
    return {
      specialHoursWithinWeek: specialHoursWithinWeek
    };
  }
  var specialHoursDays = getSpecialHoursDays(specialHours, timezone);
  var today = moment().tz(timezone).startOf('day');
  var oneWeekLater = moment(today).add(6, 'days').endOf('day');
  var upcomingSpecialHours = _.filter(specialHoursDays, function (_ref4) {
    var date = _ref4.date;
    var specialHoursDate = moment.tz(date, timezone);
    return specialHoursDate.isBetween(today, oneWeekLater, undefined, '[]');
  });
  if (upcomingSpecialHours) {
    _.forEach(upcomingSpecialHours, function (day) {
      var specialHoursDayOfWeek = moment.tz(day.date, timezone).format('dddd');
      _.set(specialHoursWithinWeek, specialHoursDayOfWeek, _objectSpread(_objectSpread({}, day.hours), {}, {
        date: day.date
      }));
    });
  }
  return specialHoursWithinWeek;
};

// Updated method to work with new ordering and hours settings by type
/**
 * @typedef {import('types/graphql').GqlWeeklyHours} GqlWeeklyHours
 * @typedef {import('types/graphql').GqlSpecialHours} GqlSpecialHours
 * @typedef {import('types/graphql').GqlReservationOptionsForOrderType} GqlReservationOptionsForOrderType
 *
 * @typedef {Object} SlotsByDay
 * @property {Object} standard
 * @property {Object} special
 *
 * @typedef {Object} ReservationSlotsPerOrderTypeArgs
 * @property {boolean} orderTypeEnabled
 * @property {GqlWeeklyHours} orderTypeHours
 * @property {GqlSpecialHours[]} orderTypeSpecialHours
 * @property {GqlReservationOptionsForOrderType} orderTypeReservationConfig
 * @property {string} timezone
 * @property {string} reservationType
 * @property {string} deliveryMode
 * @property {GqlDeliveryZones[]} deliveryZones
 *
 * @callback GetReservationSlotsPerOrderType
 * @param {ReservationSlotsPerOrderTypeArgs}
 * @returns {SlotsByDay}
 */

/** @type {GetReservationSlotsPerOrderType}  */
export function getReservationSlotsPerOrderType(_ref5) {
  var _ref5$orderTypeEnable = _ref5.orderTypeEnabled,
    orderTypeEnabled = _ref5$orderTypeEnable === void 0 ? false : _ref5$orderTypeEnable,
    _ref5$orderTypeHours = _ref5.orderTypeHours,
    orderTypeHours = _ref5$orderTypeHours === void 0 ? {} : _ref5$orderTypeHours,
    _ref5$orderTypeSpecia = _ref5.orderTypeSpecialHours,
    orderTypeSpecialHours = _ref5$orderTypeSpecia === void 0 ? [] : _ref5$orderTypeSpecia,
    _ref5$orderTypeReserv = _ref5.orderTypeReservationConfig,
    orderTypeReservationConfig = _ref5$orderTypeReserv === void 0 ? {} : _ref5$orderTypeReserv,
    timezone = _ref5.timezone,
    _ref5$reservationType = _ref5.reservationType,
    reservationType = _ref5$reservationType === void 0 ? '' : _ref5$reservationType,
    _ref5$deliveryZones = _ref5.deliveryZones,
    deliveryZones = _ref5$deliveryZones === void 0 ? [] : _ref5$deliveryZones,
    _ref5$deliveryMode = _ref5.deliveryMode,
    deliveryMode = _ref5$deliveryMode === void 0 ? '' : _ref5$deliveryMode;
  var specialHoursWithinNextWeek = getSpecialHoursWithinNextWeek(orderTypeSpecialHours, timezone);
  var slotsByDay = getOrderTypeSlotsByDay(orderTypeEnabled, orderTypeHours, specialHoursWithinNextWeek, orderTypeReservationConfig || {}, reservationType, deliveryZones, deliveryMode);
  return slotsByDay;
}
export function getAdvancedDayOrderingDays(_ref6) {
  var advancedDayOrderingLimit = _ref6.advancedDayOrderingLimit,
    timezone = _ref6.timezone;
  var dayOptions = [];
  var getDayString = function getDayString(index, day) {
    var dayOfWeek = day.format('dddd');
    var labels = ['Today', 'Tomorrow'];
    return {
      day: day,
      dayOfWeek: dayOfWeek,
      label: index < labels.length ? labels[index] : dayOfWeek,
      value: index
    };
  };
  var limit = advancedDayOrderingLimit || 1;
  for (var i = 0; i <= limit; i++) {
    dayOptions.push(getDayString(i, moment.tz(timezone).add(i, 'day')));
  }
  return dayOptions;
}
export function sameDayDeliveryAdjustedOrderingDays(advancedDayOrderingLimit, timezone) {
  var options = getAdvancedDayOrderingDays({
    advancedDayOrderingLimit: advancedDayOrderingLimit,
    timezone: timezone
  });
  options.shift();
  options.forEach(function (option) {
    option.value -= 1;
  });
  return options;
}
export function getAdvancedDayOrderingTimes(_ref7) {
  var _ref7$advancedDayOrde = _ref7.advancedDayOrderingDays,
    advancedDayOrderingDays = _ref7$advancedDayOrde === void 0 ? [] : _ref7$advancedDayOrde,
    _ref7$reservationOpti = _ref7.reservationOptions,
    reservationOptions = _ref7$reservationOpti === void 0 ? [] : _ref7$reservationOpti,
    _ref7$selectedDayInde = _ref7.selectedDayIndex,
    selectedDayIndex = _ref7$selectedDayInde === void 0 ? 0 : _ref7$selectedDayInde;
  var selectedDay = advancedDayOrderingDays[selectedDayIndex];
  if (!selectedDay) {
    return [];
  }

  // Use the effective business day (dayOfWeek) instead of calendar date if extended hours is enabled as that
  // field will be provided on the reservationOptions to compare against
  var selectedDayOfWeek = selectedDay.dayOfWeek;
  var filteredOptions = _.filter(reservationOptions, function (_ref8) {
    var dayOfWeek = _ref8.dayOfWeek;
    return dayOfWeek === selectedDayOfWeek;
  });
  return _.uniqBy(filteredOptions, function (_ref9) {
    var label = _ref9.label;
    return label;
  });
}
export function generateSlotsByZone(slots, zones) {
  return Object.entries(slots).reduce(function (slotTypeAcc, _ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      slotType = _ref11[0],
      days = _ref11[1];
    slotTypeAcc[slotType] = Object.entries(days).reduce(function (dayAcc, _ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
        day = _ref13[0],
        daySlots = _ref13[1];
      dayAcc[day] = daySlots.flatMap(function (slot) {
        return zones.map(function (zone) {
          return _objectSpread(_objectSpread({}, slot), {}, {
            deliveryAreaId: zone.name,
            feeInCents: zone.feeInCents,
            minimumInCents: zone.minimumInCents,
            feeType: zone.feeType,
            percentFee: zone.percentFee,
            active: true
          });
        });
      });
      return dayAcc;
    }, {});
    return slotTypeAcc;
  }, {});
}